import { useTranslation } from 'react-i18next';

import {
  ControlledDatePicker,
  ControlledSelect,
  ControlledTextField
} from 'components/shared/ControlledFields';

export const AccountDetailAccountName = ({ control, ...props }) => {
  const { t } = useTranslation();

  return (
    <ControlledTextField
      {...props}
      label={t('accountName')}
      control={control}
      variant="outlined"
      name="accountName"
    />
  );
};

export const AccountDetailComEmail = ({ control, ...props }) => {
  const { t } = useTranslation();

  return (
    <ControlledTextField
      {...props}
      label={t('email')}
      control={control}
      variant="outlined"
      name="comEmail"
      type="email"
    />
  );
};

export const AccountDetailEmpId = ({ control, options, ...props }) => {
  const { t } = useTranslation();

  return (
    <ControlledSelect
      {...props}
      hasClearButton
      options={options}
      label={t('linkedEmployee')}
      control={control}
      variant="outlined"
      name="empId"
    />
  );
};

export const AccountDetailNameFirst = ({ control, ...props }) => {
  const { t } = useTranslation();

  return (
    <ControlledTextField
      {...props}
      label={t('firstName')}
      control={control}
      variant="outlined"
      name="nameFirst"
    />
  );
};

export const AccountDetailNameLast = ({ control, ...props }) => {
  const { t } = useTranslation();

  return (
    <ControlledTextField
      {...props}
      label={t('lastName')}
      control={control}
      variant="outlined"
      name="nameLast"
    />
  );
};

export const AccountDetailValidFrom = ({ control, ...props }) => {
  const { t } = useTranslation();

  return (
    <ControlledDatePicker
      {...props}
      fullWidth
      control={control}
      label={t('validFrom')}
      variant="outlined"
      name="valid.from"
    />
  );
};

export const AccountDetailValidTo = ({ control, ...props }) => {
  const { t } = useTranslation();

  return (
    <ControlledDatePicker
      {...props}
      fullWidth
      control={control}
      label={t('validTo')}
      variant="outlined"
      name="valid.to"
    />
  );
};
